<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useTenantStore } from '@/stores/tenant'
import LocaleSwitcher from '@/ui/LocaleSwitcher.vue'

/* Footer: only the legal links (AGB + Datenschutz) plus the quiet locale
   switcher - no descriptive text. */
const { t } = useI18n()
const tenant = useTenantStore()
</script>

<template>
  <footer class="footer">
    <div class="footer__inner">
      <a class="footer__brand" :href="tenant.current.officialUrl" target="_blank" rel="noopener">
        {{ tenant.current.name }}
      </a>
      <nav class="footer__legal" :aria-label="t('footer.legalLabel')">
        <a
          v-if="tenant.current.legal.terms"
          :href="tenant.current.legal.terms"
          target="_blank"
          rel="noopener"
        >
          {{ t('footer.terms') }}
        </a>
        <a :href="tenant.current.legal.privacy" target="_blank" rel="noopener">
          {{ t('footer.privacy') }}
        </a>
        <a :href="tenant.current.legal.imprint" target="_blank" rel="noopener">
          {{ t('footer.imprint') }}
        </a>
      </nav>
      <LocaleSwitcher class="footer__locale" />
    </div>
  </footer>
</template>

<style scoped>
.footer {
  border-top: 1px solid var(--color-border);
}

.footer__inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: var(--space-3) var(--space-5);
  max-width: var(--content-max-width);
  margin: 0 auto;
  padding: var(--space-4) var(--content-padding-x);
  font-size: var(--font-size-xs);
  letter-spacing: var(--tracking-label);
  color: var(--color-text-muted);
}

/* Brand link (official website, not the portal) sits on the far left; the
   margin-right:auto pushes the legal links + locale switcher to the right.
   Wraps onto its own row on narrow screens. */
.footer__brand {
  margin-right: auto;
  color: var(--color-text-muted);
  text-decoration: none;
  letter-spacing: var(--tracking-label);
}

.footer__brand:hover {
  color: var(--color-brand);
}

.footer__legal {
  display: flex;
  gap: var(--space-4);
}

.footer__legal a {
  color: var(--color-text-muted);
}

.footer__legal a:hover {
  color: var(--color-brand);
}
</style>
